import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import { connect } from "react-redux"
import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'

import {hideSnackbar} from '../actions/snackbarActions'

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class SimpleSnackbar extends React.Component {
  handleClose = () => {
    this.props.dispatch(hideSnackbar())
  }

  render() {
    const { classes } = this.props

    return (
      <Snackbar
        anchorOrigin={{
          vertical: this.props.snackbar.verticalPosition,
          horizontal: this.props.snackbar.horizontalPosition,
        }}
        open={this.props.snackbar.show}
        autoHideDuration={this.props.snackbar.duration}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          'className': classes[this.props.snackbar.variant],
        }}
        message={
            <span id="client-snackbar" className={classes.message}>
              <Icon type={this.props.snackbar.variant} className={`${classes.icon} ${classes.iconVariant}`} />
              {this.props.snackbar.message}
            </span>
        }
        action={[

          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={this.handleClose}>
            <CloseIcon />
          </IconButton>,
        ]}
      />
    )
  }
}

function Icon(props){
  switch (props.type) {
    case "success": {
      return <CheckCircleIcon />
    }
    case "warning": {
      return <WarningIcon />
    }
    case "error": {
      return <ErrorIcon />
    }
    case "info": {
      return <InfoIcon />
    }
    default:{
      return null
    }
  }
}


const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  snackbar: state.snackbar
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SimpleSnackbar))



// WEBPACK FOOTER //
// ./src/js/components/Snackbar.js